import api from "@/api";
import { getError } from "@/utils/error";
import { setDate } from "@/plugins/dateFilters.js";
import { notificationCategories, } from "@/utils/notification.js";

export const state = {
  type: null,
  dateLastUpdate: null,
  notifications: [],
  isLoading: true,
};

export const mutations = {
  success(state, message) {
    state.type = "alert-success";
    state.message = message;
  },
  setDateLastUpdate(state, date) {
    state.dateLastUpdate = date;
  },
  clear(state) {
    state.type = null;
    state.message = null;
  },
  setNotifications(state, items) {
    state.notifications = items;
    state.isLoading = false;
  },
  addNotification(state, item) {
    state.notifications.unshift(item);
  },
  updateNotifications(state, items) {
    state.notifications.forEach((notification) => {
      const item = items.find((i) => i.id == notification.id);
      if (item) {
        notification.date_hidden = item.date_hidden;
        notification.date_read = item.date_read;
      }
    });
  },
  updateNotification(state, item) {
    let notification = state.notifications.find((i) => i.id == item.id);
    if (notification) {
      notification.date_hidden = item.date_hidden;
      notification.date_read = item.date_read;
    }
  },
  deleteNotification(state, id) {
    const notification = state.notifications.find((i) => i.id == id);
    if (!notification) return;
    const index = state.notifications.indexOf(notification);
    state.notifications.splice(index, 1);
  },
  deleteNotifications(state, ids) {
    ids.forEach((id) => {
      const notification = state.notifications.find((i) => i.id == id);
      if (!notification) return;
      const index = state.notifications.indexOf(notification);
      state.notifications.splice(index, 1);
    });
  },
};
export const getters = {
  isLoading(state) {
    return state.isLoading;
  },
  news(state) {
    return state.notifications.filter(
      (notification) => !notification.date_read
    );
  },
  notifications(state) {
    return state.notifications.filter(
      (notification) => notification.category == notificationCategories.notification
    );
  },
  reminders(state) {
    return state.notifications.filter(
      (notification) => notification.category == notificationCategories.reminder
    );
  },
  messages(state) {
    return state.notifications.filter(
      (notification) => notification.category == notificationCategories.message
    );
  },
};

export const actions = {
  success({ commit }, message) {
    commit("success", message);
  },
  error({ commit }, message) {
    commit("setNotifications", message);
  },
  clear({ commit }) {
    commit("clear");
  },
  async setNotifications({ commit }, { userId }) {
    try {
      /*      let messages = new Map();
           let threads = new Map();
           let persons = new Map(); */
      commit("setDateLastUpdate", new Date());
      const notifications = await api.notifications.get({
        user_id: { _eq: userId },
        date_hidden: { _null: "true" },
      });
      commit("setNotifications", notifications);
    } catch (error) {
      getError(error);
    }
  },
  async getNewNotifications({ state, commit }, { userId }) {
    try {
      const last_update = state.dateLastUpdate;
      commit("setDateLastUpdate", new Date());
      const notificationsItems = await api.notifications.get({
        user_id: { _eq: userId },
        date_hidden: { _null: "true" },
        date_created: {
          _gte: setDate(last_update),
        },
      });
      if (notificationsItems.length == 0) return;

      notificationsItems.forEach((notification) => {

        commit("addNotification", {
          ...notification,

        })
      });
    } catch (error) {
      getError(error);
    }
  },
  async viewNotificationsByIds({ state, commit }) {
    try {
      const date_read = new Date();
      const res = await api.notifications.readByIds(
        state.notifications.map((el) => {
          return el.id;
        }),
        setDate(date_read)
      );

      commit("updateNotifications", res);
    } catch (error) {
      getError(error);
    }
  },
  async viewNotificationById({ commit }, id) {
    try {
      const date_read = new Date();
      const res = await api.notifications.readById(id, setDate(date_read));

      commit("updateNotification", res);
    } catch (error) {
      getError(error);
    }
  },
  async hideNotificationById({ commit }, id) {
    try {
      await api.notifications.hideById(id, setDate(new Date()));
      commit("deleteNotification", id);
    } catch (error) {
      getError(error);
    }
  },
  async hideNotificationsByIds({ commit }, ids) {
    try {
      await api.notifications.hideByIds(ids, setDate(new Date()));
      commit("deleteNotifications", ids);
    } catch (error) {
      getError(error);
    }
  },
};
